<template>
	<div>
      <v-container grid-list-xl>    
        <v-flex l3>
          <label class="blackLabel">Status Type</label>
          <v-select @input="fncReloadStatusList" :items="statusList" label="Status Type" class="dropdown" v-model="statusType" item-value="id" single-line solo></v-select>
        </v-flex>
        <v-flex xs3>
          <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table loading="true" :headers="headers" :items="objUserStatus" :search="search" hide-actions disable-initial-sort class="elevation-1 linkTable">
          <template slot="items" slot-scope="props">
            <tr class="sortableRow" id="rows">
              <td width="10%"><v-switch v-model="props.item.excluded"></v-switch></td>
              <td width="90%">{{ props.item.description }}</td>              
            </tr>
          </template>
        </v-data-table>
        <v-layout row wrap class="pl-4 pr-4 pb-4">
          <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
              <v-btn color="success" class="text-xs-right" @click.stop="fncUpdateUserStatus()">Save</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
              search: '',
              headers: [
                { text: 'Active', value: '', width: '10%' },
                { text: 'Description', value: 'description', width: '90%' }
              ],
              statusType: 'quote',              
              statusList: [
                { id: 'quote', text: 'Quote Status' },
                { id: 'rfc', text: 'RFC Status' }                
              ],
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncUpdateUserStatus() {
              this.$store.dispatch('fncUpdateUserStatus', this.globalModalParams.userId);
            },
            fncEditNotifications() {
              this.$store.dispatch('fncEditNotifications', this.globalModalParams.userId);
            },
            fncReloadStatusList() {
              this.$store.dispatch({
                type: 'fncEditStatus',
                userId: this.globalModalParams.userId,
                status: this.statusType,
                showModal: false
              })              
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
				'objUserStatus'
			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>